export type IconProps = {
  name: string;
  variant?: 'active' | 'default';
  size?: number;
  color?: string;
};

export { default as Icon } from './Icon';
